import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styles: [],
    standalone: false
})
export class PageNotFoundComponent implements OnInit {
  public constructor(private readonly titleService: Title, private readonly router: Router) { }

  public ngOnInit(): void {
    this.titleService.setTitle("Page Not Found");
  }
}
